import { gql, useQuery } from '@apollo/client';
import { useDispatch } from 'react-redux';

import { updateFormulas } from '../reducers/graph';

import { FormulaData } from '../types/kb';
import { useSpecialty, useVersion } from './useVersion';

const GET_FORMULAS_QUERY = gql`
  query Formulas($version: Float!, $specialty: String) {
    formulas(
      where: { version: { eq: $version }, specialty: { eq: $specialty } }
    ) {
      id
      name
      value
    }
  }
`;

export const useFormulas = (forceRefresh?: boolean) => {
  const dispatch = useDispatch();
  const version = useVersion();
  const specialty = useSpecialty();

  useQuery<FormulaData>(GET_FORMULAS_QUERY, {
    onError: console.log,
    variables: { version, specialty, forceRefresh },
    skip: !specialty,
    onCompleted: (data) => {
      dispatch(updateFormulas(data.formulas));
    },
  });
};
